import { ExclamationCircleIcon } from '@heroicons/react/24/solid';

export function ApiError({ error }) {
  if (!error) return null;

  return (
    <div className="bg-coral-400 text-xs flex items-center gap-1.5 p-2 rounded-lg text-white">
      <ExclamationCircleIcon className="size-5 text-white shrink-0" />
      <span>{error}</span>
    </div>
  );
}
